import React, { useState } from "react";
import { FaMapMarkerAlt,  FaUserAlt} from "react-icons/fa";
import Table from 'react-bootstrap/Table'
import Modal from 'react-bootstrap/Modal';
import { MdSmartphone, MdEdit, MdMarkEmailRead} from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import PageEditForm from "./pageEditForm";
import 'react-phone-number-input/style.css'
import { elakayAutoText } from "../../pageInside/dataElakay";

// Edit modal redesign: the header used to be a flat teal bar with a
// completely EMPTY <Modal.Title/> -- no text at all, whichever field you
// were editing. Same icon-circle + title + subtitle header language the
// rest of this page's cards already use (.uart-sign-card-header/
// .uart-form-icon-circle), just picked per field so the modal always says
// what it's actually for.
const EDIT_FIELD_META = {
    fullName: { Icon: FaUserAlt, title: () => elakayAutoText("h_uart_editName_title", "Edit your name"), subtitle: () => elakayAutoText("h_uart_editName_subtitle", "Update your first name, last name, or both.") },
    email: { Icon: MdMarkEmailRead, title: () => elakayAutoText("h_uart_editEmail_title", "Edit your email"), subtitle: () => elakayAutoText("h_uart_editEmail_subtitle", "This is the address you'll use to sign in.") },
    passWord: { Icon: RiLockPasswordFill, title: () => elakayAutoText("h_uart_editPassword_title", "Change your password"), subtitle: () => elakayAutoText("h_uart_editPassword_subtitle", "Choose a new password for your account.") },
    telephone: { Icon: MdSmartphone, title: () => elakayAutoText("h_uart_editPhone_title", "Manage phone numbers"), subtitle: () => elakayAutoText("h_uart_editPhone_subtitle", "Add a new number or remove one you no longer use.") },
    address: { Icon: FaMapMarkerAlt, title: () => elakayAutoText("h_uart_editAddress_title", "Edit your address"), subtitle: () => elakayAutoText("h_uart_editAddress_subtitle", "Keep your shipping address up to date.") },
};

const GetEditInfoUser = (props) => {
    const {
        checkInfoUser,
        userInfo,
        token,
        infoSource,
        setPagesUser,
        bnTelephone,
        setUserInfo,
        loadingUserAct,
        relaodFonctionToken
            } = props
            const [showEditNameModal, setShowEditNameModal] = useState(false);
            const [shooseEdit, setShooseEdit] = useState(false);


            const editMeta = EDIT_FIELD_META[shooseEdit] || EDIT_FIELD_META.fullName;
            const EditIcon = editMeta.Icon;

            const AddTermsAndConditions = () => (
                <div className="contaire">
                    <div className="row justify-content-center " >
                        <Modal
                            show={showEditNameModal}
                            onHide={() => setShowEditNameModal(false)}
                            dialogClassName={`uart-edit-modal-dialog${shooseEdit === 'address' ? ' uart-edit-modal-dialog--wide' : ''}`}
                            contentClassName="uart-modal-content uart-edit-modal-content"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton className="uart-modal-header uart-edit-modal-header">
                                <div className="uart-edit-modal-heading">
                                    <span className="uart-edit-modal-icon"><EditIcon /></span>
                                    <div>
                                        <Modal.Title id="example-custom-modal-styling-title" className="uart-edit-modal-title">
                                            {editMeta.title()}
                                        </Modal.Title>
                                        <p className="uart-edit-modal-subtitle">{editMeta.subtitle()}</p>
                                    </div>
                                </div>
                            </Modal.Header>
                            <Modal.Body className="uart-modal-body uart-edit-modal-body">

                           <PageEditForm
                              setUserInfo={setUserInfo} 
                              bnTelephone={bnTelephone}
                            setPagesUser={setPagesUser}
                           editShoose={shooseEdit}
                           infoSource={infoSource}
                           checkInfoUser={checkInfoUser}
                           userInfo ={userInfo}
                           token={token}
                           loadingUserAct={loadingUserAct}
                           relaodFonctionToken={relaodFonctionToken}
                           setShowEditNameModal={setShowEditNameModal}
                           />

                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            )

const bntEdit = (a, b, c)=>{
  return  <button type="button" className="uart-edit-icon-btn" onClick={()=>{ b(true);  a(c) }} aria-label={elakayAutoText("h_5301648dcf6b53", "Edit")}>
    <MdEdit />
  </button>
}
            const infoUser = (
          
                     
                        <div className="m-3 uart-info-summary">
                        <Table className="uart-info-table">
                            <tbody>
                           { checkInfoUser(userInfo, 'firstname', 'edit') && checkInfoUser(userInfo, 'lastname', 'edit') && <tr>
                                <td><span className="uart-info-icon"><FaUserAlt /></span> </td>
                                <td><h4>{userInfo.firstname} {userInfo.lastname} </h4></td>
                                <td>{bntEdit(setShooseEdit, setShowEditNameModal, 'fullName')}  </td>
                            </tr>}
                        {  checkInfoUser(userInfo, 'email', 'edit') &&  <tr>
                                <td><span className="uart-info-icon"><MdMarkEmailRead /></span> </td>
                                <td><h4> {`${userInfo.email}`} </h4></td>
                                <td>{bntEdit(setShooseEdit, setShowEditNameModal, 'email')}  </td>
                            </tr>}
                            <tr>
                                <td><span className="uart-info-icon"><RiLockPasswordFill /></span> </td>
                                <td><h4>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addUserGetEditInfoUser.t001}</h4></td>
                                <td>{bntEdit(setShooseEdit, setShowEditNameModal, 'passWord')}  </td>
                            </tr>

                    {
                     userInfo.telephone && userInfo.telephone?.map((k,i)=>(
                      
                    <tr key={i}>
                        <td><span className="uart-info-icon"><MdSmartphone/></span> </td>
                        <td><h4> {`${k.International}`} </h4></td>
                        <td>{bntEdit(setShooseEdit, setShowEditNameModal, 'telephone')}</td>
                    </tr>
                        ))}
            

                           {userInfo.address && userInfo.address?.map((m, i) => (
                
                    <tr  key={i}>   
                                <td><span className="uart-info-icon"><FaMapMarkerAlt /></span> </td>
                                <td><h4>{m.firstName} {m.lastName}<br /> {m.Address1}, {m.city} {m.State} {m.postalCode} {m.country}</h4></td>
                                <td>{bntEdit(setShooseEdit, setShowEditNameModal, 'address')}</td>
                       
                    </tr>
                        
                     ))
                        }
                            </tbody>
                        </Table>
                    </div>
            ) 

   
       
    return   <div className="row mt-4 mb-4 justify-content-center uart-edit-summary-step">
            <div className="col col-12 col-md-10 col-lg-8 col-xl-7 p-0 uart-inline-panel" >
                <div className="col col-12 col-md-12 uart-inline-panel-header">
                </div>
                { AddTermsAndConditions()} 
         <div className="m-4">
       {infoUser}
       </div>
         </div>
        </div>

 
    
           
     
    
};

export default GetEditInfoUser;
